export const enum ModalTypes {
  alert = 'alert',
  confirm = 'confirm',
  prompt = 'prompt',
  password = 'password',
  default = 'default',
  form = 'form',
  forceChoice = 'forceChoice',
  fixed = 'fixed',
  textarea = 'textarea'
}

export const enum AppModalCancelTypes {
  close = 'close',
  cancel = 'cancel',
  blur = 'blur',
  escape = 'escape',
  enter = 'enter',
  click = 'click'
}

export const enum UsageTypes {
  Beginner = 'beginner',
  Prototyper = 'prototyper',
  Advance = 'advanced',
  Production = 'production'
}